import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { Button } from 'app/components';
import TermsAndConditions from '../../../event-create/components/step-1/termsAndConditions';

const Terms = (props) => {
  const {
    formData,
    onChange,
    readOnly,
  } = props;

  const [data, setData] = useState(formData);
  const [loading, setLoading] = useState(false);

  const { activeRequests } = useSelector((state) => state.app);

  useEffect(() => {
    if (activeRequests?.includes('save-event')) {
      setLoading(true);
    } else {
      setLoading(false);
    }
  }, [activeRequests]);

  useEffect(() => {
    setData(formData);
  }, [formData]);

  const handleSave = () => {
    onChange(data, 'Saved');
  };

  return (
    <div className='h-full pt-[36px] px-[80px] flex flex-col gap-9'>
      <h1 className='heading-24'>Terms and Conditions</h1>
      <div className='flex flex-col'>
        <TermsAndConditions
          showHeader={false}
          setFormData={setData}
          formData={data}
          disabled={readOnly}
        />
      </div>
      <Button type='primary'
        onClick={handleSave}
        disabled={readOnly}
        loading={loading}
        className="mt-auto mb-4 flex self-center">
          Save
      </Button>
    </div>
  );
};

export default Terms;
